<template>
  <div class="home-content-page-v" id="result-page">
    <div class="choose-show-cases">
      <el-checkbox-group v-model="showCasesName" size="large" fill="#324057" @change="gooter" text-color="#a4aebd" :min="1">
        <el-checkbox-button v-for="caseOne in casesEle" :label="caseOne.name" :disabled="caseOne.status !== 30" :key="caseOne.name">{{caseOne.name}}</el-checkbox-button>
      </el-checkbox-group>
      <a class="case-db" href="javascript:;" @click="goCompare">方案对比</a>
    </div>
    <div class="ele-result-list">
      <div v-for="(showCase, index) in showCases" class="ele-result-one">
        <div class="data-title" :id="index + '_case'">
          {{showCase.name}}
        </div>
        <div class="data-chat-2">
          <div class="case-info">
            <div class="case-info-one">
              <span>天气</span><span>{{showCase.d1}}</span>
            </div>
            <div class="case-info-one">
              <span>光伏成本</span><span>{{showCase.d2}}</span>
            </div>
            <div class="case-info-one">
              <span>固定存储容量</span><span>{{showCase.d3}}</span>
            </div>
            <div class="case-info-one">
              <span>SOC下限</span><span>{{showCase.d4}}</span>
            </div>
            <div class="case-info-one">
              <span>SOC上限</span><span>{{showCase.d5}}</span>
            </div>
            <div class="case-info-one">
              <span>SOC初始值</span><span>{{showCase.d6}}</span>
            </div>
            <div class="case-info-one">
              <span>储能放电成本</span><span>{{showCase.d7}}</span>
            </div>
          </div>
          <div class="case-info">
            <div class="case-info-one" v-for="(data, key) in showCase.result.logfile">
              <span>{{key}}</span><span>{{data}}</span>
            </div>
            <div class="case-info-one show-detail">
              <a class="" href="javascript:;" @click="dialog_content=showCase.result.CompleteLogfile;dialogVisible=true">详 细</a>
            </div>
          </div>
          <div class="map-page map-page-pre" :id="'chart-2-' + showCase.index">
          </div>
        </div>
        <!-- <div class="data-chat">
          <div class="map-page map-page-line" :id="'chart-' + showCase.index">
          </div>
        </div> -->
        <div class="data-table">
          <mii-table :datas="showCase.result['调度方案']" :table_style="2" :ths="ths" title="结果" scroll_table="true" :table_height="16" output_file="true"></mii-table>
        </div>
      </div>
    </div>
    <el-dialog title="详细" :visible.sync="dialogVisible" size="" :before-close="handleClose">
      <p v-for="data in dialog_content">{{data}}</p>
    </el-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import MiiTable from '../../components_bit/MiiTable'
  import CaseCompareTable from '../../components_bit/CaseCompareTable'
  import {
    initChatContinuousOption,
    initChatPreOption
  } from '../../eleChatOption'
  export default {
    components: {
      MiiTable,
      CaseCompareTable
    },
    data () {
      return {
        dialogVisible: false,
        dialog_content: '',
        oldLength: '',
        ths: [{
          label: '时间',
          key: 0
        },
        {
          label: '光伏发电',
          key: 2
        },
        {
          label: '购电量',
          key: 4
        },
        {
          label: '卖电量',
          key: 5
        },
        {
          label: '电池充电',
          key: 7
        },
        {
          label: '电池放电',
          key: 8
        },
        {
          label: 'SOC',
          key: 9
        }]
      }
    },
    methods: {
      goCompare () {
        this.$router.push({name: 'ele_compare'})
      },
      handleClose () {
        this.dialogVisible = false
      },
      gooter (value) {
        if (this.oldLength > value.length) {
          return
        }
        let goCaseName = value[value.length - 1]
        let showIndex = 0
        this.showCases.forEach(function (item, index) {
          if (item.name === goCaseName) {
            showIndex = index
          }
        })
        let dom = document.getElementById('result-page')
        dom.scrollTop = dom.scrollHeight / this.showCases.length * showIndex
        this.oldLength = value.length
      },
      initCat1 (caseData, index, num) {
        let data = this.$store.getters.sourceDataEle.load
        let myChat = window.echarts.init(document.getElementById('chart-' + index))
        let chatData = {max: 0, xData: [], yData: [[], [], []], legend: ['光伏发电', '负荷', 'SOC']}
        caseData.forEach(function (item, index) {
          chatData.max = chatData.max < item[2] ? item[2] : chatData.max
          chatData.xData.push(item[0])
          chatData.yData[0].push(item[2])
          chatData.yData[1].push(data[index][1])
          chatData.yData[2].push(item[9] * num)
        })
        myChat.setOption(initChatContinuousOption(chatData), true)
      },
      initCat2 (caseData, index) {
        let myChat = window.echarts.init(document.getElementById('chart-2-' + index))
        let data = [{
          name: '购电成本',
          value: caseData[0]
        },
        {
          name: '储能成本',
          value: caseData[1]
        },
        {
          name: '光伏发电成本',
          value: caseData[2]
        }]
        myChat.setOption(initChatPreOption(data))
      }
    },
    computed: {
      eleStatus: {
        get () {
          return this.$store.getters.eleStatus
        }
      },
      showCasesName: {
        get () {
          return this.$store.getters.showCasesName
        },
        set (value) {
          this.$store.dispatch('setShowCasesName', value)
        }
      },
      casesEle: {
        get () {
          return this.$store.getters.casesEle
        }
      },
      showCases: {
        get () {
          let vm = this
          let newData = []
          if (this.casesEle) {
            this.casesEle.forEach(function (item, index) {
              if (vm.showCasesName.indexOf(item.name) > -1) {
                item.index = index
                newData.push(item)
                Vue.nextTick(function () {
                  // vm.initCat1(item.result['调度方案'], index, Number(item.d3.split('k')[0]))
                  vm.initCat2(item.result['成本'][0], index)
                })
              }
            })
          }
          return newData
        }
      }
    },
    created () {
      if (this.eleStatus < 10) {
        this.$router.push({name: 'ele_import'})
      }
    },
    mounted () {
      if (this.showCasesName.length === 0) {
        let newData = []
        this.casesEle.forEach(function (item) {
          if (item.status === 30) {
            newData.push(item.name)
          }
        })
        this.showCasesName = newData.slice(0, 2)
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../style/base.less';
  .case-db {
    color: #a4aebd;
    background-color: #324057;
    line-height: 2.5rem;
    padding: 0 1rem;
    border-radius: 0.3rem;
  }
  .dialog-choose-show-cases {
    margin-bottom: 2rem;
  }
  .home-content-page-v {
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .dialog-content {
    display: flex;
    flex-direction:column;
  }
  .show-detail {
    align-self: flex-end;
    flex: 0.5 !important;
    display: flex;
    align-items: center;
    a {
      border-radius: 0.2rem;
      background-color: rgb(50, 64, 87);
      color: #fff;
      font-size: 0.8rem;
      height: 1.2rem;
      padding: 0.1rem 0.5rem;
    }
  }
  .data-title {
    width: 100%;
    font-size: 1.3rem;
    color: @bak-color-2;
  }
  .data-chat {
    height: 22rem;
    width: 100%;
    margin-bottom: 1rem;
  }
  .data-chat-2 {
    height: 22rem;
    display: flex;
    margin-bottom: 1rem;
  }
  .case-info {
    display: flex;
    flex: 1;
    padding: 1rem;
    margin:1rem;
    border-radius: 1rem;
    color: #666;
    flex-direction:column;
    border: 1px solid #aaa;
  }
  .case-info-one {
    display: flex;
    flex: 1;
    justify-content: space-between;
  }
  .map-page-pre {
    width: 40%;
  }
  .map-page-line {
    width: 100%;
  }
  .map-page {
    height: 22rem;
  }
  .choose-show-cases {
    display: flex;
    min-height: 3rem;
    justify-content:space-between;
    align-items: center;
  }
  .ele-result-list {
    display: block;
  }
  .ele-result-one {
    background: #fff;
    border-radius: 1rem;
    padding: 1rem;
    margin-top: 1rem;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction:column;
  }
</style>



// WEBPACK FOOTER //
// ele_result.vue?449c3479